import { render, staticRenderFns } from "./VaAccordion.vue?vue&type=template&id=57aa3940&"
import script from "./VaAccordion.vue?vue&type=script&lang=js&"
export * from "./VaAccordion.vue?vue&type=script&lang=js&"
import style0 from "./VaAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports